import { filesize } from "filesize";
import { formatDistanceToNow } from "date-fns";

/*
 * asRelativeDate function
 * Formats a string as a relative data.
 */
export const asRelativeDate = (dateString: string): string => {
  return formatDistanceToNow(new Date(dateString), { addSuffix: true });
};

/*
 * asColor function
 * Formats a percentage as a HEX value.
 */
export const asColor = (percentage: number) => {
  if (percentage < 5) return "#DC3545";
  if (percentage < 15) return "#DC5335";
  if (percentage < 25) return "#DC7135";
  if (percentage < 35) return "#CE9321";
  if (percentage < 45) return "#D0AF00";
  if (percentage < 55) return "#C8C000";
  if (percentage < 65) return "#9EBE00";
  if (percentage < 75) return "#80B918";
  if (percentage < 85) return "#55A630";
  return "#198754";
};

/*
 * asFileSize function
 * Formats a string using the FileSize library.
 */
export const asFileSize = (number: number) => {
  return number ? filesize(number, { standard: "jedec" }) : "---";
};

/**
 * isoDateFormat function
 * Formats an ISO date string into "DD Month YYYY, time AM/PM".
 * e.g. 02 Apr 2025, 10:30 am
 */
export const isoDateFormat = (isoDateString: string): string => {
  const date = new Date(isoDateString);
  const options: Intl.DateTimeFormatOptions = {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  };
  return date.toLocaleString("en-UK", options);
};

/**
 * Helper function to convert a string to title case
 * e.g. "brand narrative" => "Brand narrative"
 * @param string - The input string
 * @returns The title-cased string
 */
export const toTitleCase = (string: string): string => {
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
};
